import React, { useState, useEffect } from 'react'
import './Article.css'
import { Link } from 'react-router-dom'

import A2 from '../assets/A2.webp'

import Post1 from '../assets/Post1.webp'
import Post2 from '../assets/Post2.webp'

import Post3 from '../assets/Post3.webp'
import Post31 from '../assets/Post31.webp'
import Post32 from '../assets/Post32.webp'
import Post33 from '../assets/Post33.webp'
import Post34 from '../assets/Post34.webp'
import Post35 from '../assets/Post35.webp'
import Post36 from '../assets/Post36.webp'
import Post37 from '../assets/Post37.webp'
import Post38 from '../assets/Post38.webp'
import Post39 from '../assets/Post39.webp'
import Post310 from '../assets/Post310.webp'
import Post311 from '../assets/Post311.webp'

import { motion as m } from "framer-motion";
import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'
import Carousel from '../components/Carousel'

const Article3 = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

   

    const images = [
        Post31,Post32,Post33,Post34,Post35,Post36,Post37,Post38,Post39,Post310,Post311
        ];



    return (
        <m.div
            className="Article"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <div className="Article-page">
                <div className="Article-main">
                    <div className="Article-header">
                        <div className="Article-header-top">
                            <div className="Article-header-top-breadcrumb">
                            <Link to="/news"> <div className="Article-header-top-breadcrumb-text1">{t('NewsP1')}</div></Link>
                               {/* <div className="Article-header-top-breadcrumb-text2">5 key generative AI use cases in insurance distribution</div>*/}
                            </div>
                            {deviceWidth > 768 &&
                                <div className="Article-header-top-date">Jan 30,2024</div>}
                        </div>
                        {/*<div className="Article-info">
                            <p className="Article-info-title">5 key generative AI use cases in insurance distribution</p>
                            {deviceWidth >= 768 &&
                                (<div className="Article-author-top-right">
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Facebook} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Twitter} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Linkedin} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Link1} className="Article-author-top-right-social-icon" />
                                    </div>
                                </div>
                                )}
                            </div>*/}

                    </div>

                    <img loading="lazy" decoding="async" alt="" src={Post3} className="Article-main-image" />

                    <div className="Article-main-text">
                    Dear Partners,
                    <br/>
                    On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers Association. We invited speakers Harry O'Riordan and Josh Hearnden, local insurance market and stakeholders to discuss key security issues in post-conflict areas, with a particular focus on the Karabakh region of Azerbaijan.
                    <br/>
                    At the Seminar we have discussed the details and aspects of political violence insurance that can work as a risk mitigation mechanism for investors in Karabakh, and we are confident that the experience and support of our partners will enable these instruments to be adapted and implemented in Karabakh.
                    <br/>
                    We would like to express our sincere gratitude to everyone for their active participation and valuable questions that helped deepen the discussions. We hope that our event will be a great start for further cooperation in the field of security in post-conflict areas.
                    <br/>
                      </div>
                            <Carousel images={images}/>
                </div>

                <div className="Article-rec">
                    <p className="Article-rec-header">{t("NewsP3")}</p>
                    <div className="Article-rec-bottom">

                    <Link to='/article1'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post1} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                    {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Mar 30,2024</p>

                            </div>
                        </div></Link>

                        <Link to='/article2'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post2} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                    {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance."
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Mar 6,2024</p>

                            </div>
                        </div></Link>


                        <Link to='/article3'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post3} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                     {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    Dear Partners,
On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Jan 30,2024</p>

                            </div>
                        </div></Link>



                        {deviceWidth <= 1023 && deviceWidth >= 768 && (

<Link to='/article1'>
<div className="Article-rec-element">

    <img loading="lazy" decoding="async" alt="" src={A2} className="Article-rec-element-img" />
    <div className="Article-rec-element-info">
        <div className="Article-rec-element-info-top">
             {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
            <div className="Article-rec-element-info-top-header-text">
                With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </div>
        </div>
        <p className="Article-rec-element-info-bottom-frame-time">Aug 19, 2024</p>

    </div>
</div></Link>


                        )
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </m.div>
    )
}

export default Article3